import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Formata bytes em string legível (B/KB/MB/GB/TB). Helper compartilhado —
 * vários componentes do Drive/Documentos tinham cópias locais; o
 * DocumentPreviewDialog importa esta versão de `@/lib/utils`.
 */
export function formatBytes(bytes?: number | null, decimals = 1): string {
  if (!bytes || bytes <= 0) return "0 B";
  const k = 1024;
  const sizes = ["B", "KB", "MB", "GB", "TB"];
  const i = Math.min(Math.floor(Math.log(bytes) / Math.log(k)), sizes.length - 1);
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(decimals))} ${sizes[i]}`;
}
